import React from "react";
import PropTypes from "prop-types";
import Markdown from "solar/components/Markdown";
import IconNext from "solar/icons/IconNext";
import IconPrevious from "solar/icons/IconPrevious";
import Title from "components/shared/stays/Title";
import Modal from "components/shared/stays/Modal";
import ModalBody from "components/shared/stays/ModalBody";
import ButtonImage from "solar/components/ButtonImage";
import GalleryTwoUp from "components/shared/stays/GalleryTwoUp";
import SectionRhythm from "components/shared/stays/SectionRhythm";
import styles from "components/stay/ProductsModal.module.scss";

export default function ProductsModal({
  visibleProducts,
  showModal,
  activeProduct,
  setActiveProduct,
  handleModalClose,
  tripTypeDescription,
}) {
  const numProducts = visibleProducts.length;
  const startIndex = visibleProducts.findIndex(
    (product) => product.id === activeProduct
  );

  function handleNext() {
    if (startIndex === numProducts - 1) {
      setActiveProduct(visibleProducts[0].id);
    } else {
      setActiveProduct(visibleProducts[startIndex + 1].id);
    }
  }

  function handlePrevious() {
    if (startIndex === 0) {
      setActiveProduct(visibleProducts[numProducts - 1].id);
    } else {
      setActiveProduct(visibleProducts[startIndex - 1].id);
    }
  }

  const navigation = (
    <div className={styles.navbar}>
      <div className={styles.count}>
        {startIndex + 1}
        {" / "}
        {numProducts}
      </div>
      <div className={styles.controls}>
        <ButtonImage
          onClick={() => handlePrevious()}
          className={styles.control}
        >
          <IconPrevious />
        </ButtonImage>
        <ButtonImage onClick={() => handleNext()} className={styles.control}>
          <IconNext />
        </ButtonImage>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        show={showModal}
        handleClose={handleModalClose}
        navigation={numProducts > 1 && navigation}
        className={styles.component}
      >
        <ModalBody>
          {visibleProducts.map((product) => (
            <React.Fragment key={product.id}>
              {activeProduct === product.id && (
                <div>
                  <div className={styles.name}>
                    <Title size={4}>{product.name}</Title>
                  </div>
                  {product.product_images.length > 0 && (
                    <GalleryTwoUp
                      photos={product.product_images}
                      photoAlt={product.name}
                      showButton
                      buttonText={`Show ${product.product_images.length} ${
                        tripTypeDescription === "Boat" ? "route" : "room"
                      } photos`}
                    />
                  )}
                  <SectionRhythm>
                    <Markdown>{product.description}</Markdown>
                  </SectionRhythm>
                </div>
              )}
            </React.Fragment>
          ))}
        </ModalBody>
      </Modal>
    </div>
  );
}

ProductsModal.propTypes = {
  visibleProducts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      price: PropTypes.string,
      product_images: PropTypes.arrayOf(
        PropTypes.shape({
          file: PropTypes.shape({
            url: PropTypes.string,
          }),
        })
      ),
      direction: PropTypes.string,
      type: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
  showModal: PropTypes.bool.isRequired,
  activeProduct: PropTypes.string.isRequired,
  setActiveProduct: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  tripTypeDescription: PropTypes.string.isRequired,
};
